/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Verified = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Verified 24">
      <path
        fill="#5E1FF0"
        fillRule="evenodd"
        d="M21.587 14.94 24 11.825 21.587 8.71l.121-3.938-3.783-1.102L15.708.413 12 1.745 8.292.413 6.075 3.67 2.292 4.772l.121 3.938L0 11.825l2.413 3.115-.121 3.939 3.783 1.101 2.217 3.258L12 21.905l3.708 1.333 2.217-3.258 3.783-1.101-.121-3.939Zm-3.884-5.404a1 1 0 1 0-1.406-1.422L9.9 14.42l-2.197-2.15a1 1 0 0 0-1.406 1.421l2.9 2.846a1 1 0 0 0 1.406 0l7.1-7Z"
        className="Fill-Main"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const VerifiedIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'verified-icon'}
      icon={Verified}
      {...props}
      size={size}
    />
  );
};
